import { logEvent } from '../services/services';
import { hashCode, normalizeErrorStack } from '../utils/utilsGlobal';

export default class BaseSubscription {

  eventHandlers = {};

  getCallbackUniqueHash = (callback) => {
    const callStackHash = hashCode(
      normalizeErrorStack(new Error().stack, 3)
    );
    const functionCodeHash = hashCode(callback.toString());
    return Math.abs(functionCodeHash + callStackHash);
  };

  triggerEvent = (eventName, data, options) => {
    options = options || {};
    logEvent(eventName, { ...data, firedOnce: options.firedOnce });

    if (!this.eventHandlers[eventName]?.callbacks) {
      this.eventHandlers[eventName] = { callbacks: {} };
    }
    const eventHandler = this.eventHandlers[eventName];
    eventHandler.firedOnce = options.firedOnce;
    if (options.firedOnce) {
      eventHandler.firedOnceArguments = data;
    }
    Object.values(eventHandler.callbacks).forEach(callback => callback(data));
  };

  on = (eventName, callback) => {
    if (eventName instanceof Array) {
      eventName.map(singleEventName => this.on(singleEventName, callback));
    }
    else {
      if (!this.eventHandlers[eventName]?.callbacks) {
        this.eventHandlers[eventName] = { callbacks: {} };
      }
      const eventHandler = this.eventHandlers[eventName];

      // Prevents subscribing to the same event with the same callback multiple times when the same component
      // mounts/unmounts periodically (e.g. when user switches back and forth from PageProfile to PageChat)
      const hash = this.getCallbackUniqueHash(callback);
      eventHandler.callbacks[hash] = callback;
      if (eventHandler.firedOnce) {
        callback(eventHandler.firedOnceArguments);
      }
    }
  };

  off = (eventName, callback) => {
    if (!this.eventHandlers[eventName]?.callbacks) {
      this.eventHandlers[eventName] = { callbacks: {} };
    }
    const eventHandler = this.eventHandlers[eventName];
    if (callback) {
      for (let hash in eventHandler.callbacks) {
        const currentCallback = eventHandler.callbacks[hash];
        if (currentCallback === callback) {
          delete eventHandler.callbacks[hash];
          return;
        }
      }
    }
    else {
      eventHandler.callbacks = {};
    }
  };
}
